const PAGES_ID = {
  app: 'app_data',
  main: 'main_data',
  results: 'results'
};

export default PAGES_ID;
